<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      :actions="actions"
      ref="grid"
      navigationPath="HelpDeskRequestView"
      navigationField="displayID"
      :selectionEnabled="true"
      :onLoaded="mapResults"
    ></dx-grid>

    <v-dialog persistent v-model="newTicketDialog" max-width="800">
      <v-card>
        <v-card-title>
          <span class="headline">New request</span>
        </v-card-title>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-select
                  v-model="newTicket.priority"
                  :items="['High', 'Normal', 'Low']"
                  label="Priority"
                  ref="newTicketSelectedPriority"
                  :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  v-model="newTicket.category"
                  :items="[
                    'Telephone',
                    'Desktop / Laptop /Server',
                    'Printers / scanner / Fax',
                    'Software',
                    'Camera',
                  ]"
                  label="Category"
                  ref="newTicketCategory"
                ></v-select>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="newTicket.subject"
                  label="Enter a brief title for your request"
                  ref="newTicketSubject"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-Textarea
                  v-model="newTicket.description"
                  label="Write a message"
                  outline
                  ref="newTicketDescription"
                ></v-Textarea>
              </v-flex>

              <v-flex xs12>
                <span>This information is optional but recommended:</span>
              </v-flex>
              <v-icon>mdi-phone</v-icon>
              <v-flex xs12 sm5>
                <v-text-field
                  v-model="newTicket.phone"
                  label="Phone Number"
                  browser-autocomplete="tel"
                  type="tel"
                  hint="We'll use this to contact you about your ticket"
                  persistent-hint
                >
                </v-text-field>
              </v-flex>

              <v-flex xs12 sm3>
                <v-text-field
                  v-model="newTicket.ext"
                  label="Ext Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="newTicket.room"
                  label="Room Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm8>
                <v-btn
                  small
                  class="ml-0 mt-0"
                  color="success"
                  :loading="uploading"
                  @click="pickFile()"
                  >Upload Files
                  <v-icon right small>mdi-cloud-upload</v-icon></v-btn
                >
                <input
                  type="file"
                  multiple
                  style="display: none"
                  ref="files"
                  @change="onFilePicked($event)"
                />
              </v-flex>

              <v-card
                v-for="(file, index) in fileUploadList"
                style="border: 1px solid #4caf50; border-radius: 5px; margin-right: 10px;"
                class="pa-2 my-2"
              >
                <v-layout row justify-space-between style="width: 250px;">
                  <div class="mt-0 ml-0 pt-1">
                    {{ truncateText(file.name, 18) }}
                  </div>
                  <v-btn
                    color="success"
                    class="my-0 mr-1"
                    small
                    @click="removeUploadImg(index)"
                  >
                    remove
                  </v-btn>
                </v-layout>
              </v-card>
            </v-layout>
          </v-container>

          <v-card-actions class="pb-3">
            <!-- <v-btn flat small v-if="!newTicket.showNotificationEmailField" color="success" @click="newTicket.showNotificationEmailField = true" > {{ "Add Additional Recipient" }} </v-btn> <v-btn flat small v-if="newTicket.showNotificationEmailField" color="red" @click=" (newTicket.showNotificationEmailField = false), (newTicket.notificationEmails = '') " > {{ "Remove" }} </v-btn> <v-flex v-if="newTicket.showNotificationEmailField"> <v-text-field v-model="newTicket.notificationEmails" label="To send a copy of the ticket to another email, Enter a valid email" type="Email" :rules="[rules.email]" ></v-text-field> </v-flex> -->
            <v-spacer></v-spacer>

            <v-btn
              color="default"
              @click="reset"
              :dark="!cancelBtnAbility"
              :disabled="cancelBtnAbility"
              >Cancel</v-btn
            >
            <v-btn
              :loading="processing"
              dark
              color="success"
              @click="saveNewTicket"
              :dark="!sendBtnDisability"
              :disabled="sendBtnDisability"
              >Send</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";
export default {
  data: () => ({
    cancelBtnAbility: false,
    sendBtnDisability: false,
    title: "Support Tickets",
    url: "",
    actions: [],
    newTicketDialog: false,
    processing: false,
    uploading: false,
    fileUploadList: [],
    includeClosed: false,

    newTicket: {
      subject: "",
      description: "",
      category: "",
      priority: "Normal",
      phone: "",
      room: "",
      ext: "",
      //notificationEmails: "", showNotificationEmailField: false,
    },

    rules: {
      required: (value) => !!value || "Required.",
      // email: (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( v ) || "Enter a valid email",
    },

    columns: [
      {
        field: "priority",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          return "mdi-box-shadow";
        },
        iconColor: (value) => {
          switch (value) {
            case "1 High":
            case "3 Option 8":
              return "#e74c3c";
            case "2 Normal":
              return "#f39c12";
            case "4 Low":
              return "#7f8c8d";
            default:
              return "#bdc3c7";
          }
        },
      },
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          switch (value) {
            case "Closed":
              return "mdi-check-circle";
            case "Open":
            case "Reopened":
              return "mdi-clock";
            case "On Hold":
              return "mdi-clock";
            case "Canceled":
              return "mdi-cancel";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "Closed":
              return "#2ecc71";
            case "Open":
            case "Reopened":
              return "#f1c40f";
            case "On Hold":
              return "#3498db";
            case "Canceled":
              return "#e74c3c";
            default:
              return "#bdc3c7";
          }
        },
      },
      //{ label: "Status", field: "statusName", visible: true, filterValues: [], filterValue: null, selectedFilterOperation: null, },
      {
        label: "Ticket Number",
        field: "displayID",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        link: "HelpDeskRequestView",
        template: "link-cell-template",
      },
      {
        label: "Subject",
        field: "subject",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        cssClass: "width-300",
      },
      {
        label: "Requester Email",
        field: "requesterEmail",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Created At",
        field: "createdAt",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Technician",
        field: "technicianName",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Due By",
        field: "dueByTimeDateTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Sync Time",
        field: "lastSyncTime",
        visible: true,
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Source",
        field: "source",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "User",
        field: "username",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Site",
        field: "siteName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Department",
        field: "departmentName",
        visible: false,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // { label: "Technician Email", field: "technicianEmail", visible: true, filterValues: [], filterValue: null, selectedFilterOperation: null, },
    ],
  }),

  created() {
    if (this.$route.query.showClosed) {
      this.includeClosed = true;
    }

    if (this.$route.query.openNewTicket) {
      this.openNewTicket();
    }

    this.actions.push({
      text: "Show Closed",
      type: "switch",
      align: "left",
      value: this.includeClosed,
      action: this.onShowClosedChanged,
    });

    this.actions.push({
      text: "New Ticket",
      action: this.openNewTicket,
    });
  },

  methods: {
    async beforeSetupGrid() {
      this.url = `manageengine?includeClosed=${
        this.includeClosed
      }&filterForUser&filterForTechnician`;
    },

    onShowClosedChanged(value) {
      this.includeClosed = value;
      this.url = `manageengine?includeClosed=${
        this.includeClosed
      }&filterForUser&filterForTechnician`;
      this.$refs.grid.reloadDataSource(this.url);
    },

    async openNewTicket() {
      this.newTicketDialog = true;
      this.fileUploadList = [];
    },
    async saveNewTicket() {
      const filesId = [];
      for (var i = 0; i < this.fileUploadList.length; i++) {
        filesId.push(this.fileUploadList[i].file_id);
      }
      if (!this.$refs.form.validate(true)) {
        return;
      }
      try {
        this.processing = true;
        this.cancelBtnAbility = true;
        const hasUserInfo =
          this.newTicket.phone ||
          this.newTicket.room.trim() ||
          this.newTicket.ext.trim();

        const userInfo = [
          this.newTicket.phone
            ? `<b>Phone</b>: ${this.newTicket.phone}<br>`
            : "",
          this.newTicket.room.trim()
            ? `<b>Room</b>: ${this.newTicket.room.trim()}<br>`
            : "",
          this.newTicket.ext.trim()
            ? `<b>Ext</b>: ${this.newTicket.ext.trim()}`
            : "",
        ]
          .filter(Boolean)
          .join("");

        const desc = `${this.newTicket.description.trim()}${
          hasUserInfo ? `<br><br><br><br>${userInfo}` : ""
        }`;
        const description = desc
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");
        const priorityMap = {
          High: "3 Option 8",
          Normal: "2 Normal",
          Low: "4 Low",
        };

        const response = await this.$http.post(
          "api/Manageengine/ManageenginePost",
          {
            User: this.$store.state.authentication.user,
            Subject: this.newTicket.subject.trim(),
            Description: description,
            Priority: priorityMap[this.newTicket.priority],
            Category: this.newTicket.category
              ? this.newTicket.category
              : "Untitled",
            Attachments: filesId[0] ? JSON.stringify(filesId) : "",
            // NotificationEmails: this.newTicket.notificationEmails,
          }
        );

        this.processing = false;
        this.cancelBtnAbility = false;

        this.$notify({
          text: "Ticket Created",
          group: "notification",
          type: "success",
        });
        this.reset();
        this.$refs.grid.reloadGrid();
        this.$router.push({
          name: "HelpDeskRequestView",
          params: { id: response.request.display_id },
        });
      } catch (e) {
        this.processing = false;
        this.cancelBtnAbility = false;
        alert(
          `We're sorry, but your ticket could not be submitted. Please contact support at extension #12340 and provide your username: ${
            this.$store.state.authentication.user
          }`
        );
      }
    },

    reset() {
      this.newTicketDialog = false;
      this.newTicket = {
        subject: "",
        description: "",
        category: "",
        priority: "Normal",
        phone: "",
        room: "",
        ext: "",
      };
      // this.newTicket.notificationEmails = ""; this.newTicket.showNotificationEmailField = false;
      this.removeAllUploadImg();
      this.$refs.form.resetValidation(true);
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;
      this.sendBtnDisability = true;
      const files = e.target.files;

      if (!files) return;
      try {
        for (var i = 0; i < files.length; i++) {
          var formData = new FormData();
          formData.append("file", files[i]);
          const response = await this.$http.post(
            "api/Manageengine/ManageengineUpload",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          this.fileUploadList.push(response.files[0]);
        }
        this.uploading = false;
        this.sendBtnDisability = false;
        this.$refs.files.value = null;
      } catch (e) {
        this.uploading = false;
      }
    },
    removeUploadImg(index) {
      this.fileUploadList.splice(index, 1);
    },
    removeAllUploadImg() {
      this.fileUploadList = [];
      this.uploading = false;
      this.sendBtnDisability = false;
      this.$refs.files.value = null;
    },
    truncateText(text, count = 25) {
      return truncate(text, count);
    },

    reloadGrid() {
      this.$refs.grid.reloadGrid();
    },
    mapResults(results) {
      results.map((t) => {
        t.technicianName =
          t.technicianName == "UserPortal" ? "" : t.technicianName;
        return t;
      });
    },
  },
};
</script>
<style scoped>
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink 1.5s infinite;
}
</style>
